import HowCanSpiceHelpMyFacility from "../../components/request-support/how-can-spice-help-my-facility";

const HowCanSpiceHelpMyFacilityPage = () => (
    <HowCanSpiceHelpMyFacility />
);

export default HowCanSpiceHelpMyFacilityPage;